import { useContext } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'
import { PassImage } from '/components/editor/pass-image'

const GoogleLogo = () => {

  const { classData, objectData, variables, passType } = useContext(PassContext)

  const sources = getLogoImage({ classData, objectData, variables, passType })
  const cardTitle = getCardTitle({ classData, objectData, variables, passType })

  const imageSrc = sources.wideLogo.value ? sources.wideLogo.value : sources.logo.value
  const captureSrc = imageSrc

  if (sources.wideLogo.value) {
    return (
      <>
        <div className="flex flex-row items-center gap-2 basis-full">
          <PopupEditor sources={sources} type="logo" logoType="wideLogo" title="Logo Image">
            <div className="wide-logo-editable editable">
              <PassImage src={imageSrc} captureSrc={captureSrc} className="wide-logo" />
            </div>
          </PopupEditor>
        </div>
        <hr />
      </>
    )
  } else {
    return (
      <>
        <div className="flex flex-row items-center gap-2 basis-full">
          <PopupEditor sources={sources} type="logo" logoType="logo" title="Logo Image">
            <div className="logo-editable editable">
              <PassImage src={imageSrc} captureSrc={captureSrc} className="logo" />
            </div>
          </PopupEditor>

          <PopupEditor title={cardTitle.title} path={cardTitle.path} sources={cardTitle.sources} required={true} variable={cardTitle.variable}>
            <div className="logo-text text-nowrap truncate editable">{cardTitle.value}</div>
          </PopupEditor>
        </div>
        <hr />
      </>
    )
  }
}

export default GoogleLogo


const getLogoImage = ({ classData, objectData, variables, passType }) => {
  try {

    switch (passType) {
      case "generic":
        {
          const logoUrl = dataSelector({ objectData, variables, path: "logo.sourceUri.uri" })
          const wideLogoUrl = dataSelector({ objectData, variables, path: "wideLogo.sourceUri.uri" })

          return {
            source: "object",
            logo: {
              path: "logo.sourceUri.uri",
              value: logoUrl ? logoUrl : null
            },
            wideLogo: {
              path: "wideLogo.sourceUri.uri",
              value: wideLogoUrl ? wideLogoUrl : null
            }
          }
        }

      case "flight":
        {
          const logoUrl = dataSelector({ objectData:classData, variables, path: "flightHeader.carrier.airlineLogo.sourceUri.uri" })
          const wideLogoUrl = dataSelector({ objectData:classData, variables, path: "flightHeader.carrier.wideAirlineLogo.sourceUri.uri" })

          return {
            source: "class",
            logo: {
              path: "flightHeader.carrier.airlineLogo.sourceUri.uri",
              value: logoUrl ? logoUrl : null
            },
            wideLogo: {
              path: "flightHeader.carrier.wideAirlineLogo.sourceUri.uri",
              value: wideLogoUrl ? wideLogoUrl : null
            }
          }
        }

      case "transit":
        {
          const logoUrl = objectData.logo ? dataSelector({ objectData, variables, path: "logo.sourceUri.uri" }) : dataSelector({ objectData:classData, variables, path: "logo.sourceUri.uri" })
          const wideLogoUrl = objectData.wideLogo ? dataSelector({ objectData, variables, path: "wideLogo.sourceUri.uri" }) : dataSelector({ objectData:classData, variables, path: "wideLogo.sourceUri.uri" })

          return {
            source: "class",
            logo: {
              path: "logo.sourceUri.uri",
              value: logoUrl ? logoUrl : null
            }, wideLogo: {
              path: "wideLogo.sourceUri.uri",
              value: wideLogoUrl ? wideLogoUrl : null
            }
          }
        }

      case "eventTicket":
        {
          const logoUrl = dataSelector({ objectData:classData, variables, path: "logo.sourceUri.uri" })
          const wideLogoUrl = dataSelector({ objectData:classData, variables, path: "wideLogo.sourceUri.uri" })

          return {
            source: "class",
            logo: {
              path: "logo.sourceUri.uri",
              value: logoUrl ? logoUrl : null
            },
            wideLogo: {
              path: "wideLogo.sourceUri.uri",
              value: wideLogoUrl ? wideLogoUrl : null
            }
          }
        }

      case "giftCard":
        {
          const logoUrl = dataSelector({ objectData:classData, variables, path: "programLogo.sourceUri.uri" })
          const wideLogoUrl = dataSelector({ objectData:classData, variables, path: "wideProgramLogo.sourceUri.uri" })

          return {
            source: "class",
            logo: {
              path: "programLogo.sourceUri.uri",
              value: logoUrl ? logoUrl : null
            },
            wideLogo: {
              path: "wideProgramLogo.sourceUri.uri",
              value: wideLogoUrl ? wideLogoUrl : null
            }
          }
        }

      case "loyalty":
        {
          const logoUrl = dataSelector({ objectData:classData, variables, path: "programLogo.sourceUri.uri" })
          const wideLogoUrl = dataSelector({ objectData:classData, variables, path: "wideProgramLogo.sourceUri.uri" })

          return {
            source: "class",
            logo: {
              path: "programLogo.sourceUri.uri",
              value: logoUrl ? logoUrl : null
            },
            wideLogo: {
              path: "wideProgramLogo.sourceUri.uri",
              value: wideLogoUrl ? wideLogoUrl : null
            }
          }
        }

      case "offer":
        {
          const logoUrl = dataSelector({ objectData:classData, variables, path: "titleImage.sourceUri.uri" })
          const wideLogoUrl = dataSelector({ objectData:classData, variables, path: "wideTitleImage.sourceUri.uri" })

          return {
            source: "class",
            logo: {
              path: "titleImage.sourceUri.uri",
              value: logoUrl ? logoUrl : null
            },
            wideLogo: {
              path: "wideTitleImage.sourceUri.uri",
              value: wideLogoUrl ? wideLogoUrl : null
            }
          }
        }
    }
  }
  catch (err) {
    console.error("Error destructuring logo variables, path")
  }
}

const getCardTitle = ({ classData, objectData, variables, passType }) => {

  try {
    switch (passType) {
      case "generic":
        {
          return {
            path: "cardTitle.defaultValue.value",
            title: "Card Title",
            sources: ["object"],
            variable : "pass.title",
            value: dataSelector({ objectData, variables, path: "cardTitle.defaultValue.value" })
          }
        }

      case "loyalty":
      case "flight":
      case "eventTicket":
      case "transit":
      case "giftCard":
      case "offer":
        {
          return {
            path: "issuerName",
            title: "Issuer Name",
            sources: ["class"],
            variable : "pass.issuer_name",
            value: dataSelector({ objectData: classData, variables, path: "issuerName" })
          }
        }
    }
  }
  catch (err) {
    console.error("Mandatory title missing")
    throw err
  }
}
